export { SESSION_STATUS } from '@or-sdk/hitl';
export * from './agents';
export * from './common';
export * from './session-events';
export * from './layout';

export const LOCAL_STORAGE_KEYS = {
  AGENT_UI_SETTINGS: 'Agent-UI-Settings',
  SESSION_VIEWS: 'Session-Views',
  EVENT_TEMPLATES: 'Event-Templates',
  ACW_SETTINGS: 'ACW-settings',
  LAYOUT_SETTINGS: 'UI-Layout-Settings',
  /** Per-workspace lastSeenUpdatedAt for workspaces active on this machine; used to show "default layout updated" toast when default's updatedAt > lastSeenUpdatedAt */
  LAYOUT_DEFAULT_VERSION_SEEN: 'UI-Layout-Default-Version-Seen',
  LAUNCHER_SETTINGS: 'App-Launcher-Settings',
  MOBILE_LOCAL_SETTINGS: 'HITL-Mobile-Local-Settings',
  PERMISSIONS_POPUP: 'HITL-Permissions-Popup',
  UPDATE_STATUS: 'HITL-Update-Status',
  MIGRATIONS: 'HITL-Migrations',
  AGENT_DATA: 'Agent-Data',
  AGENT_LIST: 'HITL-Agent-List',
  CARDS_DATA: 'Cards-Data',
  /** TODO: Delete when workspace settings store is updated */
  LAYOUT: 'HITL_LOCAL_SETTINGS',
};
